module.exports = __webpack_public_path__ + "img/france.29e1ebfe.jpeg";